export { CategoryPage } from "./CategoryPage";
export type { CategoryPageProps } from "./CategoryPage";
